import axios from "axios";
import { Box, ClickAwayListener } from "@mui/material";
import React, { useEffect, useState } from "react";
import FettiInput from "../FettiInput";
import FettiAutocomplete, { OptionsPanel } from "../FettiAutocomplete";
import { debounce } from "../../utils/utils";

import { schoolSearchList } from "../../search/schools";

const search = debounce(async (searchTerm, setOptions) => {
  // const response = await axios.get(
  //   `http://universities.hipolabs.com/search?name=${searchTerm}&country=United%20States`
  // );
  // const data = response.data;
  // setOptions(data.map((d) => d.name));
  const data = schoolSearchList.filter((d) =>
    d.toLowerCase().includes(searchTerm.toLowerCase())
  );
  // sort
  data.sort();
  setOptions(data);
}, 200);

const UniversitySearch = ({ value, setValue }) => {
  const [focused, setFocused] = useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [options, setOptions] = React.useState([]);

  useEffect(() => {
    if (value.length > 0) {
      search(value, setOptions);
    }
  }, [value]);
  // useEffect(() => {
  //   if (searchTerm.length > 0) {
  //     search(searchTerm, setOptions);
  //   }
  // }, [searchTerm]);

  return (
    <ClickAwayListener onClickAway={() => setFocused(false)}>
      <Box sx={{ width: "100%", position: "relative", zIndex: 101 }}>
        <FettiInput
          onFocus={() => {
            setFocused(true);
          }}
          value={value}
          onChange={(e) => {
            // setSearchTerm(e.target.value);
            setValue(e.target.value);
          }}
          placeholder="i.e. University of California, Berkeley"
        />
        <OptionsPanel
          open={focused && options.length > 0}
          options={options}
          setValue={setValue}
          selectValue={(v) => {
            setValue(v);
            // setSearchTerm(v);
            setFocused(false);
          }}
        />
      </Box>
    </ClickAwayListener>
  );
};

export default UniversitySearch;
